import { render } from "./VModal.vue?vue&type=template&id=4fbd735d"
import script from "./VModal.vue?vue&type=script&lang=js"
export * from "./VModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__